<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/organization/process/packing/new_package.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link :text="$t('labels.go_back_link')" :name="routeName('show_harvested_batch')" :params="{
    organization_id: organization_id,
    harvested_batch_id: harvested_batch_id
  }" />

  <bread-crumbs :labels="[
    module_name,
    harvested_batch.harvest_process?.name,
    harvested_batch.batch_code
  ]" />

  <template v-if="load_general_data">
    <harvested-batch-info :harvested_batch="harvested_batch" />

    <alert-danger class="mt-8" :errors_data="std_err" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-300">
            <template v-for="(item, index) in new_packages" :key="index">
              <div v-if="!item._remove" :key="index">
                <div class="flex justify-end sm:col-span-6" :class="{ 'pt-3': index != 0 }">
                  <button type="button" @click.prevent="new_packages[index]._remove = true" class="btn-white">
                    <i class="fas fa-xmark fa-2xl md:fa-lg text-red-500" />
                  </button>
                </div>
                <PackageNew v-model="new_packages[index]" :organization_id="organization_id"
                  :harvested_batch_id="harvested_batch_id" :producers="producers" :exporter_process_crop_categories="exporter_process_crop_categories
                    " :exporter_process_crop_varieties="exporter_process_crop_varieties
    " :exporter_process_crop_sizes="exporter_process_crop_sizes" :exporter_process_crop_packages="exporter_process_crop_packages
    " :exporter_process_brands="exporter_process_brands" :harvested_batch="harvested_batch"
                  :process_lines="process_lines" :packing_house_processes="packing_house_processes"
                  :customers="customers" />
              </div>
            </template>
            <div class="flex justify-end pt-4">
              <white-button @click.prevent="addNewPackage" label="Añadir empaque" />
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions space-y-3 my-3 md:space-y-0 md:my-0">
            <white-button @click.prevent="goToShowHarvestedBatch()" :label="$t('labels.cancel_button')" />
            <span class="space-actions"></span>
            <success-button v-if="!charging_submit" @click.prevent="create()" :label="$t('labels.save_button')" />
            <success-button-processing v-else :label="$t('labels.save_button')" />
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/process/packing/manage_package.js";
import RequesterQuery from "@/views/organization/requesters/process/packing/queries_to_package.js";
import HarvestedBatchInfo from "@/components/views/organization/process/packing/HarvestedBatchInfo.vue";
import PackageNew from "@/components/views/organization/process/packing/PackageNew.vue";

export default {
  name: "OrgProcessPackingNewPackage",
  components: { HarvestedBatchInfo, PackageNew },
  data() {
    return {
      load_general_data: false,
      charging_submit: false,
      harvested_batch: {},
      producers: [],
      exporter_process_crop_packages: [],
      exporter_process_crop_categories: [],
      exporter_process_crop_varieties: [],
      exporter_process_crop_sizes: [],
      exporter_process_brands: [],
      process_lines: [],
      packing_house_processes: [],
      customers: [],
      pkg: {
        producer_id: null,
        exporter_process_crop_package_id: null,
        exporter_process_crop_category_id: null,
        exporter_process_crop_variety_id: null,
        exporter_process_crop_size_id: null,
        exporter_process_brand_id: null,
        process_line_id: null,
        quantity: null,
        exported_batch: {
          packing_house_process_id: null,
          crop_field_id: null
        },
        _remove: false
      },
      crop_field_certifications: [],
      crop_fields: [],
      new_packages: []
    };
  },
  props: {
    organization_id: { required: true },
    harvested_batch_id: { required: true }
  },
  computed: {
    packages_params() {
      return this.new_packages
        .filter(pkg => !pkg._remove)
        .map(pkg => {
          delete pkg._remove;
          return pkg;
        });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchProducers();
      await this.fetchHarvestedBatch();
      await this.fetchProcessLines();
      await this.fetchExporterProcessCropCategories();
      await this.fetchExporterProcessCropVarieties();
      await this.fetchExporterProcessCropSizes();
      await this.fetchCustomers();
      await this.fetchExporterProcessCropPackages();
      await this.fetchExporterProcessBrands();
      await this.fetchPackingHouseProcesses();
      this.load_general_data = true;
      this.addNewPackage();
    },
    addNewPackage: function () {
      let pkg = { ...this.pkg, exported_batch: { packing_house_process_id: null, crop_field_id: null } };
      pkg.exported_batch = { ...this.pkg.exported_batch }

      this.new_packages.push(pkg);
    },
    fetchHarvestedBatch: async function () {
      const response = await Requester.fetchHarvestedBatch(
        this.organization_id,
        this.harvested_batch_id
      );
      this.harvested_batch = response.data;
      this.harvest_process_id = this.harvested_batch.harvest_process_id;
      this.pkg.producer_id = this.harvested_batch.producer_id;
    },
    fetchProducers: async function () {
      const response = await RequesterQuery.fetchProducers(
        this.organization_id,
        this.harvested_batch_id
      );
      this.producers = response.data;
      this.producers.forEach(producer => {
        producer.label = `${producer.organization_producer_code} - ${producer.fullname}`;
      });
    },
    fetchProcessLines: async function () {
      const response = await RequesterQuery.fetchProcessLines(
        this.organization_id,
        this.harvested_batch_id
      );
      this.process_lines = response.data;
      this.pkg.process_line_id =
        this.hasOneItem(this.process_lines) ||
        this.harvested_batch.process_line_id;
    },
    fetchExporterProcessCropCategories: async function () {
      const response = await RequesterQuery.fetchExporterProcessCropCategories(
        this.organization_id,
        this.harvested_batch_id
      );
      this.exporter_process_crop_categories = response.data;
      const exportable = this.exporter_process_crop_categories.filter(category => category.exportable)
      if (exportable.length == 1) {
        this.pkg.exporter_process_crop_category_id = exportable[0].id;
      } else {
        this.pkg.exporter_process_crop_category_id = this.hasOneItem(
          this.exporter_process_crop_categories
        );
      }
    },
    fetchExporterProcessCropVarieties: async function () {
      const response = await RequesterQuery.fetchExporterProcessCropVarieties(
        this.organization_id,
        this.harvested_batch_id
      );
      this.exporter_process_crop_varieties = response.data;
      this.pkg.exporter_process_crop_variety_id = this.hasOneItem(
        this.exporter_process_crop_varieties
      );
    },
    fetchExporterProcessCropSizes: async function () {
      const response = await RequesterQuery.fetchExporterProcessCropSizes(
        this.organization_id,
        this.harvested_batch_id
      );
      this.exporter_process_crop_sizes = response.data;
      this.pkg.exporter_process_crop_size_id = this.hasOneItem(
        this.exporter_process_crop_sizes
      );
    },
    fetchExporterProcessCropPackages: async function () {
      const response = await RequesterQuery.fetchExporterProcessCropPackages(
        this.organization_id,
        this.harvested_batch_id
      );
      this.exporter_process_crop_packages = response.data;
      this.pkg.exporter_process_crop_package_id = this.hasOneItem(
        this.exporter_process_crop_packages
      );
    },
    fetchExporterProcessBrands: async function () {
      const response = await RequesterQuery.fetchExporterProcessBrands(
        this.organization_id,
        this.harvested_batch_id
      );
      this.exporter_process_brands = response.data;
      this.pkg.exporter_process_brand_id = this.hasOneItem(
        this.exporter_process_brands
      );
    },
    fetchPackingHouseProcesses: async function () {
      const response = await RequesterQuery.fetchPackingHouseProcesses(
        this.organization_id,
        this.harvested_batch_id
      );
      this.packing_house_processes = response.data;
      this.pkg.exported_batch.packing_house_process_id = this.hasOneItem(
        this.packing_house_processes
      );
    },
    fetchCustomers: async function() {
      const response = await RequesterQuery.fetchCustomers(
        this.organization_id,
        this.harvested_batch_id
      );
      this.customers = [...response.data, { id: null, name: 'Sin cliente' }];
    },
    create: async function () {
      this.charging_submit = true;
      try {
        let response = await Requester.create(
          this.organization_id,
          this.harvested_batch_id,
          { packages: this.packages_params }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowHarvestedBatch();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.charging_submit = false;
    },
    hasOneItem: function (array) {
      return array.length == 1 ? array[0].id : null;
    },
    goToShowHarvestedBatch: function () {
      this.$router.push({
        name: this.routeName("show_harvested_batch"),
        params: {
          organization_id: this.organization_id,
          harvested_batch_id: this.harvested_batch_id
        }
      });
    }
  }
};
</script>
